import { createFileRoute } from "@tanstack/react-router"
import { MagicNumbersAdmin } from "../admin/magic-numbers"

export const Route = createFileRoute("/_authed/host/magic-numbers")({
  component: MagicNumbersAdmin,
})
